import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "hn-wrap"
};
var _hoisted_2 = {
  class: "hn-icon"
};
var _hoisted_3 = {
  key: 0,
  class: "hn-badge"
};
var _hoisted_4 = {
  class: "hn-panel list-none py-0 px-0 m-0 border-round lg:border-1 border-50 lg:shadow-2 lg:absolute surface-overlay hidden origin-top z-5"
};
var _hoisted_5 = {
  class: "flex align-items-center justify-content-between px-3 py-2 border-bottom-1 surface-border"
};
var _hoisted_6 = {
  key: 0,
  class: "p-4 text-center text-500 text-sm"
};
var _hoisted_7 = {
  key: 1,
  class: "p-4 text-center text-500 text-sm"
};
var _hoisted_8 = {
  key: 2,
  class: "hn-list"
};
var _hoisted_9 = ["onClick"];
var _hoisted_10 = {
  class: "hn-body"
};
var _hoisted_11 = {
  class: "hn-title"
};
var _hoisted_12 = {
  key: 0,
  class: "hn-sub"
};
var _hoisted_13 = {
  class: "hn-time"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Button = _resolveComponent("Button");
  var _directive_styleclass = _resolveDirective("styleclass");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("a", {
    class: "flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-indigo-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple hn-bell",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $options.opened();
    })
  }, [_createElementVNode("span", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("i", {
    class: "pi pi-bell text-white"
  }, null, -1)), $data.unread ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($data.unread > 99 ? "99+" : $data.unread), 1)) : _createCommentVNode("", true)]), _cache[3] || (_cache[3] = _createElementVNode("span", {
    class: "ml-2 lg:hidden font-medium"
  }, "Notifications", -1))])), [[_directive_styleclass, {
    selector: '@next',
    enterFromClass: 'hidden',
    enterActiveClass: 'scalein',
    leaveToClass: 'hidden',
    leaveActiveClass: 'fadeout',
    hideOnOutsideClick: true
  }]]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[4] || (_cache[4] = _createElementVNode("span", {
    class: "font-semibold text-900"
  }, "Notifications", -1)), $data.unread ? (_openBlock(), _createBlock(_component_Button, {
    key: 0,
    label: "Mark all read",
    text: "",
    size: "small",
    onClick: _cache[1] || (_cache[1] = _withModifiers(function ($event) {
      return $options.markAll();
    }, ["stop"]))
  })) : _createCommentVNode("", true)]), $data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Loading…")) : !$data.items.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Nothing yet. Client decisions on review links will show up here.")) : (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.items, function (n) {
    return _openBlock(), _createElementBlock("a", {
      key: n.id,
      class: _normalizeClass(["hn-item", {
        unread: !n.read_at
      }]),
      onClick: _withModifiers(function ($event) {
        return $options.open(n);
      }, ["prevent"])
    }, [_createElementVNode("span", {
      class: _normalizeClass(["hn-dot", $options.kindClass(n)])
    }, null, 2), _createElementVNode("span", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(n.title), 1), n.body ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(n.body), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_13, _toDisplayString($options.ago(n.created_at)), 1)])], 10, _hoisted_9);
  }), 128))]))])]);
}